import React, { useState, useEffect } from "react";

function Vodka_BeerBottled() {

    const [vodka, setVodka] = useState([]);
    const [beerBottled, setBeerBottled] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then((data) => {
            const categoryVodka = data.data.find(item => item.name === 'WÓDKA');
            const categoryBeerBottled = data.data.find(item => item.name === 'PIWO BUTELKOWE');

            if (categoryVodka) {
                setVodka(categoryVodka.menu_items);
            }

            if (categoryBeerBottled) {
                setBeerBottled(categoryBeerBottled.menu_items);
            }
            
        })

    }, []);

    return(

        <div className="container-fluid pt-4">
            <div className="container">
                <div className="menu-item-title-section d-flex justify-content-between align-items-end">
            <p className="menu-item-title-font m-0 fs-1 fw-bold pt-5">WÓDKI</p>
            <p className="fs-5 m-1 fw-light">40 / 500ml</p>
            </div>
            <hr/>
            {vodka.map((vodka) => (
                <div key={vodka.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{vodka.name}</p>
                        <p className="fs-5 m-0">{vodka.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{vodka.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
            </div>
            <div className="container">
            <p className="menu-item-title-font fs-1 fw-bold pt-5">PIWA BUTELKOWE</p>
            <hr/>
            {beerBottled.map((beerBottled) => (
                <div key={beerBottled.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{beerBottled.name}</p>
                        <p className="fs-5 m-0">{beerBottled.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{beerBottled.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
            </div>
        </div>
    )
}

export default Vodka_BeerBottled;